<template>
  <div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { ReceiptService } from '@/services/receipts.service'
  export default {
    data() {
      return {
        loading: false,
        key: this.$route.params.key,
        token: JSON.parse(localStorage.getItem('userData')).token,
      }
    },
    created() {
      this.downloadFile()
    },
    methods: {
      async downloadFile() {
        try {
          this.loading = true
          await ReceiptService.downloadReceipts(this.key, this.token)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style></style>
